// extracted by mini-css-extract-plugin
export default {"q-question-answer-modal":"LPfSUM5aZqTwa3fWI7b4","qQuestionAnswerModal":"LPfSUM5aZqTwa3fWI7b4"};